import { BACKEND_ROUTES } from "../../backendRoutes";
import { PAGINATION } from "../../constants";
import useSWR from "swr";

/**
 * Builds the `GET /trained-models` URL with query params translated from
 * the job spec's `trainedModelFilters`. Returns `null` when `filters` is
 * falsy, which causes the SWR call to skip fetching.
 *
 * @param {{ kind?: string, task?: string, system?: string }} [filters] -
 *     filter values from the job spec; field names map to the backend's
 *     query params, with `kind` renamed to `TrainedModelKind_name`.
 * @returns {string|null} the request URL, or `null` to skip the fetch.
 */
function buildTrainedModelsUrl(filters) {
    if (!filters) return null;
    const params = new URLSearchParams({
        trainedModelVersions: true,
        // Eager-load the crops each model is associated with (incl. the
        // nested `Crop` object) so the selector can group by crop.
        trainedModelCrops: true,
        // TODO: handle pagination if the dataset outgrows GENERIC.MAX
        limit: PAGINATION.GENERIC.LIMIT.MAX,
    });
    if (filters.kind != null) params.set("TrainedModelKind_name", filters.kind);
    if (filters.task != null) params.set("task", filters.task);
    if (filters.system != null) params.set("system", filters.system);
    return `${BACKEND_ROUTES.TRAINED_MODEL}?${params.toString()}`;
}

export const useTrainedModels = (filters) =>
    useSWR(buildTrainedModelsUrl(filters));
